import React from 'react';
import { ClipboardListIcon, DraftingCompassIcon, ListChecksIcon, RulerIcon, StoreIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { BONUS_VALUE, bonuses } from '../data/content';
const ICONS = {
  compass: DraftingCompassIcon,
  ruler: RulerIcon,
  checks: ListChecksIcon,
  clipboard: ClipboardListIcon,
  store: StoreIcon
};

/* Colores de cada bono, igual que en la portada del pack */
const BONUS_COLORS = ['bg-red-600', 'bg-blue-700', 'bg-green-700', 'bg-orange-600', 'bg-purple-700'];
export function BonusesSection() {
  return <section aria-labelledby="bonos" className="bg-paper text-ink" data-id="element-27" data-mp="1ej4c2ixc59t9">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-28" data-mp="1elgoyho8ktzg">
        <h2 id="bonos" className="font-anton text-3xl uppercase leading-tight sm:text-4xl" data-id="element-29" data-mp="19lly2e4go4ee">
          <span className="bg-gold px-1.5" data-id="element-30" data-mp="1nhzh3ron8duz">5 Bonos incluidos</span>
        </h2>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-snug text-steel" data-id="element-31" data-mp="1jk1rinqynpr2">
          Y además recibís 5 recursos prácticos —{' '}
          <strong className="font-extrabold text-forge" data-id="element-32" data-mp="3psoiwb0isboq">GRATIS</strong> con tu
          compra.
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-33" data-mp="2lm5d1zyicki">
          {bonuses.map((bono, i) => {
          const Icon = ICONS[bono.icon];
          return <Reveal key={bono.title} as="li" delay={i * 0.03} className="flex h-full flex-col overflow-hidden rounded-lg border-2 border-gold bg-white text-left" data-id="element-34" data-mp="7ma469uffxpa" data-mpi={i}>
                <span className={`flex items-center gap-1.5 px-2.5 py-1 text-xs font-black uppercase tracking-wider text-white ${BONUS_COLORS[i]}`} data-id="element-35" data-mp="lcdlqnid338e">
                  <Icon size={12} aria-hidden="true" data-id="element-36" data-mp="qd1dxcibtq47" />
                  Bono {i + 1} — Gratis
                </span>
                <div className="flex flex-1 flex-col p-2.5" data-id="element-37" data-mp="1094lixvy6gyj">
                  <h3 className="text-sm font-extrabold uppercase leading-tight" data-id="element-38" data-mp="107a0zkol8quz">
                    {bono.title}
                  </h3>
                  <p className="mt-0.5 text-xs leading-snug text-steel sm:text-sm" data-id="element-39" data-mp="5me31t76a2sm">
                    {bono.desc}
                  </p>
                  <p className="mt-auto pt-1.5 text-sm font-extrabold uppercase tracking-wide text-steel line-through decoration-forge decoration-2" data-id="element-40" data-mp="kbtrv3n57y5o">
                    {bono.value}
                  </p>
                </div>
              </Reveal>;
        })}
        </ul>

        <div className="mt-3 inline-block rounded-lg border-2 border-dashed border-gold bg-ink px-3 py-2 text-xs font-black uppercase leading-tight text-white sm:text-sm" data-id="element-41" data-mp="oblw545i7i58">
          <p data-id="element-42" data-mp="yb31tlkr9w17">💰 Valor total de los 5 bonos: {BONUS_VALUE}</p>
          <p className="mt-0.5 text-gold" data-id="element-43" data-mp="y8qjh7b35jnm">
            🔥 Hoy los 5 están incluidos gratis.
          </p>
        </div>
      </div>
    </section>;
}